// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1tG7y","content":"LoadingAlert_content__1MK2q"};